import { render, staticRenderFns } from "./dashboardfault.vue?vue&type=template&id=38f3cbdc&scoped=true&"
import script from "./dashboardfault.vue?vue&type=script&lang=js&"
export * from "./dashboardfault.vue?vue&type=script&lang=js&"
import style0 from "./dashboardfault.vue?vue&type=style&index=0&id=38f3cbdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f3cbdc",
  null
  
)

export default component.exports